import "core-js/modules/es.string.starts-with.js";
import { defineComponent as _defineComponent } from 'vue';
import Dashboard from '~/pages/portfolio/dashboard.vue';
import { isReviewCompanyExportRoute } from '~/functions/review-export';
import { useReviewRouteGuards } from '~/functions/review';
import { AccountCategory, useGetAccountQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'portfolio',
  setup: function setup(__props) {
    var router = useRouter();
    var route = useRoute();
    var _useNuxtApp = useNuxtApp(),
      $auth = _useNuxtApp.$auth;
    var isReviewExportRoute = computed(function () {
      return isReviewCompanyExportRoute(route.path);
    });
    var _useGetAccountQuery = useGetAccountQuery({}, computed(function () {
        return {
          enabled: $auth.loggedIn
        };
      })),
      result = _useGetAccountQuery.result,
      loading = _useGetAccountQuery.loading;
    var account = computed(function () {
      var _result$value;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getAccount;
    });
    useReviewRouteGuards();

    // Redirect if account is not a portfolio
    watch(account, function (accountValue) {
      if (accountValue && !loading.value && accountValue.type !== AccountCategory.Portfolio) {
        // Only redirect if we're still on a portfolio route
        if (route.path.startsWith('/portfolio')) {
          router.push('/');
        }
      }
    }, {
      immediate: true
    });
    return {
      __sfc: true,
      router: router,
      route: route,
      $auth: $auth,
      isReviewExportRoute: isReviewExportRoute,
      result: result,
      loading: loading,
      account: account,
      Dashboard: Dashboard
    };
  }
});